import React, { useEffect, useState } from 'react';
import { PhoneIcon, CalendarIcon, MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage, TRANSLATIONS } from '../../context/LanguageContext';
export function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const {
    language
  } = useLanguage();
  const t = TRANSLATIONS[language || 'en'];
  useEffect(() => {
    const handleScroll = () => {};
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className="sticky top-0 left-0 right-0 z-50 transition-all duration-300 bg-black/95 backdrop-blur-md border-b border-[#2a2a2a] shadow-[0_2px_20px_rgba(0,0,0,0.8)]" data-id="element-224">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-225">
        <div className="flex items-center justify-between h-16 md:h-20" data-id="element-226">
          {/* Logo */}
          <a href="#" className="flex items-center" data-id="element-227">
            <img src="https://cdn.magicpatterns.com/uploads/jdtPmWnvHPcVPS46eNsPgP/logo_b.png" alt="Jonathan's Barbershop" className="h-9 md:h-11 w-auto object-contain" data-id="element-228" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" aria-label="Main navigation" data-id="element-229">
            <a href="#services" className="text-gray-300 hover:text-white transition-colors font-medium text-sm tracking-widest uppercase" style={{
            fontFamily: 'Oswald, sans-serif'
          }} data-id="element-230">
              {t.nav_services}
            </a>
            <a href="#about" className="text-gray-300 hover:text-white transition-colors font-medium text-sm tracking-widest uppercase" style={{
            fontFamily: 'Oswald, sans-serif'
          }} data-id="element-231">
              {t.nav_about}
            </a>
            <a href="#location" className="text-gray-300 hover:text-white transition-colors font-medium text-sm tracking-widest uppercase" style={{
            fontFamily: 'Oswald, sans-serif'
          }} data-id="element-232">
              {t.nav_location}
            </a>
          </nav>

          {/* Desktop CTAs */}
          <div className="hidden md:flex items-center gap-3" data-id="element-233">
            <a href="tel:7864095863" className="flex items-center gap-2 text-white border border-[#2a2a2a] hover:border-[#c41e3a] px-4 py-2 rounded transition-all duration-200 text-sm font-medium" aria-label="Call us at (786) 409-5863" data-id="element-234">
              <PhoneIcon size={15} data-id="element-235" />
              <span data-id="element-236">(786) 409-5863</span>
            </a>
            <a href="#book" className="flex items-center gap-2 bg-[#c41e3a] hover:bg-[#a01830] text-white px-5 py-2 rounded font-semibold text-sm transition-all duration-200 tracking-wide" aria-label="Book your appointment" data-id="element-237">
              <CalendarIcon size={15} data-id="element-238" />
              <span style={{
              fontFamily: 'Oswald, sans-serif',
              letterSpacing: '0.08em'
            }} data-id="element-239">
                {t.nav_book.toUpperCase()}
              </span>
            </a>
          </div>

          {/* Mobile menu button */}
          <button className="md:hidden text-white p-2" onClick={() => setMobileOpen(!mobileOpen)} aria-label={mobileOpen ? 'Close menu' : 'Open menu'} aria-expanded={mobileOpen} data-id="element-240">
            {mobileOpen ? <XIcon size={24} data-id="element-241" /> : <MenuIcon size={24} data-id="element-242" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-243">
        {mobileOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.25
      }} className="md:hidden bg-black border-t border-[#2a2a2a] overflow-hidden" data-id="element-244">
            <nav className="flex flex-col px-6 py-4 gap-4" aria-label="Mobile navigation" data-id="element-245">
              <a href="#services" onClick={() => setMobileOpen(false)} className="text-gray-300 hover:text-white py-2 text-lg tracking-widest uppercase" style={{
            fontFamily: 'Oswald, sans-serif'
          }} data-id="element-246">
                {t.nav_services}
              </a>
              <a href="#about" onClick={() => setMobileOpen(false)} className="text-gray-300 hover:text-white py-2 text-lg tracking-widest uppercase" style={{
            fontFamily: 'Oswald, sans-serif'
          }} data-id="element-247">
                {t.nav_about}
              </a>
              <a href="#location" onClick={() => setMobileOpen(false)} className="text-gray-300 hover:text-white py-2 text-lg tracking-widest uppercase" style={{
            fontFamily: 'Oswald, sans-serif'
          }} data-id="element-248">
                {t.nav_location}
              </a>
              <div className="flex flex-col gap-3 pt-2 border-t border-[#2a2a2a]" data-id="element-249">
                <a href="tel:7864095863" className="flex items-center justify-center gap-2 text-white border border-[#2a2a2a] px-4 py-3 rounded text-sm font-medium" data-id="element-250">
                  <PhoneIcon size={16} data-id="element-251" />
                  <span data-id="element-252">(786) 409-5863</span>
                </a>
                <a href="#book" onClick={() => setMobileOpen(false)} className="flex items-center justify-center gap-2 bg-[#c41e3a] text-white px-4 py-3 rounded font-semibold text-sm" data-id="element-253">
                  <CalendarIcon size={16} data-id="element-254" />
                  <span style={{
                fontFamily: 'Oswald, sans-serif',
                letterSpacing: '0.08em'
              }} data-id="element-255">
                    {t.nav_book.toUpperCase()}
                  </span>
                </a>
              </div>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}